
import { gql } from "apollo-angular";


export const GET_FOOTER_CATEGORIES_QUERY = (lang: string)=> gql`
{


  categories (limit:5 Rand:"true") {
      id
      name:name_${lang}
      menu_photo
      sub_categories  {
          id
          name:name_${lang}
      }
  }

  # subCategories(limit:5) {
  #     id
  #     name:name_${lang}
  #     menu_photo
  #     subCategory {
  #         id
  #         name:name_${lang}
  #     }
  # }


}
`;


export const GET_PAYMENT_TYPES_QUERY = (lang: string)=> {
  return gql `{
 paymenttypes {
   id
   name: name_${lang}
   photo
 }
  }`
};
